import { createTheme } from "@mui/material/styles";
import { COLORS, THEME } from "./styles/constants.style";

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      // main: '#305dba',
      main: "#0f3e8a",
      //"#293042"
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
  typography: {
    fontFamily: THEME.fontFamilies.primary,
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          "&.Mui-error": {
            color: COLORS.cirrus_red,
          },
        },
      },
    },
  },
});

export default theme;
